import { applyMiddleware, createStore, compose, AnyAction, Action } from 'redux';
import thunkMiddleware, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import dynamicMiddlewares from 'redux-dynamic-middlewares';

import rootReducer from 'reducers';
import slackNotifMiddleware from 'middleware/slack-notif';
import { notificationMiddleware } from 'middleware/notificationMiddleware';
import { persistStore } from 'redux-persist';

function configureStore(preloadedState = {}) {
  const middlewares = [
    thunkMiddleware,
    slackNotifMiddleware,
    notificationMiddleware
  ];

  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares, dynamicMiddlewares)
  );

  const enhancers = [middlewareEnhancer];
  const composedEnhancers: any = compose(...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);
  return store;
}

const store = configureStore();
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = ThunkDispatch<RootState, any, Action>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;

export default store;
